import { render, staticRenderFns } from "./restaurantSelector.vue?vue&type=template&id=60e6b154&scoped=true&"
import script from "./restaurantSelector.vue?vue&type=script&lang=js&"
export * from "./restaurantSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6b154",
  null
  
)

export default component.exports